// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"b28434b3","947":"883ed63b"}[chunkId] + ".chunk.css";
};